import styled from "@emotion/styled";
import { FC } from "react";

import { SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

import { AutomationsEmptyState } from "./AutomationsEmptyState";

interface IProps {
  title: string;
  description: string;
  primaryAction: {
    label: string;
    onClick: VoidFunction;
  };
}

export const AutomationsSearchEmptyState: FC<IProps> = ({ title, description, primaryAction }) => (
  <StyledAutomationsEmptyState
    title={{ text: title, size: "lg" }}
    description={description}
    primaryAction={{ ...primaryAction, kind: "secondary" }}
  />
);

const StyledAutomationsEmptyState = styled(AutomationsEmptyState)`
  margin-top: ${withVar(SpacingToken.Spacing8)};
`;
